<template>
  <div class="side">
    <div class="title">
      {{title}}
    </div>
    <div class="items">
      <ul>
      	<li @click="enterDetail(item.id)" v-for="(item,index) in list" :key="index">{{item.title || item.name}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default{
    name:'Categories',
    props:{
      list:{
        type:Array,
        default(){
          return []
        }
      },
      title:{
        type:String,
        default:''
      }

    },
    mounted() {
    },
    methods:{
      enterDetail(id){
        this.$emit('getList',id)
      }
    }
  }
</script>

<style lang="scss">
  .side{
    background-color: #fff;
    .title{
      text-align: left;
      padding: 10px 20px;
      font-weight: 700;
      font-size: 20px;
      border-bottom: 1px solid #ccc;
    }
    .items{
      padding: 10px 20px;
      ul{
        width: 100%;
        list-style: none;
        text-align: left;
        padding-left:5px;
        // list-style-image: url('https://www.runoob.com/try/demo_source/sqpurple.gif');
        list-style-image: url('../../../assets/index/flowers.png');
        li{
          cursor: pointer;
          padding: 3px 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/articles/components/Categories.vue